import { Button, Card, StatusMessage } from "@herefor/design-system";
import { PRIVACY_PAGE_MESSAGES as COPY } from "@herefor/product-language";

export type PrivacyExportState = "idle" | "working" | "ready" | "failed";

export interface PrivacySurfaceProps {
  readonly backHref: string;
  readonly canExport: boolean;
  readonly exportState: PrivacyExportState;
  readonly onExport: () => void;
}

/** The promises are deliberately finite: every sentence maps to an enforced module. */
export function PrivacySurface({
  backHref,
  canExport,
  exportState,
  onExport,
}: PrivacySurfaceProps) {
  return (
    <section className="privacy-page" data-privacy-page>
      <h1>{COPY.heading}</h1>
      <p className="privacy-page__introduction">{COPY.introduction}</p>

      <Card title={COPY.stored.title} titleLevel={2}>
        <p>{COPY.stored.body}</p>
      </Card>
      <Card title={COPY.location.title} titleLevel={2}>
        <p>{COPY.location.current}</p>
        <p>{COPY.location.production}</p>
      </Card>
      <Card title={COPY.visibility.title} titleLevel={2}>
        <p>{COPY.visibility.body}</p>
      </Card>
      <Card title={COPY.choice.title} titleLevel={2}>
        <p>{COPY.choice.body}</p>
      </Card>
      <Card title={COPY.export.title} titleLevel={2}>
        <p>{COPY.export.body}</p>
        {canExport ? (
          <Button disabled={exportState === "working"} onClick={onExport} variant="primary">
            {exportState === "working" ? COPY.export.working : COPY.export.action}
          </Button>
        ) : (
          <StatusMessage tone="info">{COPY.export.unavailable}</StatusMessage>
        )}
        {exportState === "ready" ? (
          <StatusMessage tone="success">{COPY.export.ready}</StatusMessage>
        ) : null}
        {exportState === "failed" ? (
          <StatusMessage live="assertive" tone="error">
            {COPY.export.failed}
          </StatusMessage>
        ) : null}
      </Card>

      <a href={backHref}>{COPY.backToPlan}</a>
    </section>
  );
}

export function PrivacySettingsLink({ href }: { readonly href: string }) {
  return (
    <p className="privacy-settings-link">
      <a href={href}>{COPY.settingsLink}</a>
    </p>
  );
}
